import api from '@/plugins/api'
import { handleErrors } from '@/plugins/api/handle_errors'

/**
 * @typedef BulkOperation.Operation
 * @property { string } url
 * @property { string } method
 * @property { Object | function } [params]
 * @property { function } resolve
 * @property { function } [reject]
 * @property { function } [clean]
 * @property { function } [started]
 * @property { function } [done]
 */

export default class BulkOperation {
    constructor() {
        /** @type BulkOperation.Operation[] */
        this.operations = []
    }

    /**
     * @param {boolean} [clean]
     * @param {boolean} [loading]
     * @param {Array|string|int} [operationIgnoreCode]
     * @return {Promise<T>}
     */
    async run({clean = false, loading = false, operationIgnoreCode } = {}) {
        if (loading) {
            this.operations.forEach(item => typeof item.started === 'function' && item.started())
        }

        return api('/bulk-operations', {
            method: 'POST',
            data: { routes: this.getRoutes() }
        }).then(data => {
            let responseError = null

            for (let i = 0; i < this.operations.length; i++) {
                let response = data[i]

                if (clean && typeof this.operations[i].clean === 'function') {
                    this.operations[i].clean()
                }

                if (response.error === true) {
                    responseError = response

                    if (typeof this.operations[i].reject === 'function') {
                        this.operations[i].reject({ status: response.code, data: response.result })
                    }
                } else {
                    this.operations[i].resolve(response)
                }

                if (loading && typeof this.operations[i].done === 'function') {
                    this.operations[i].done()
                }
            }

            if (responseError) {
                handleErrors({ status: responseError.code, data: responseError.result }, operationIgnoreCode)
            }

            return data
        }).catch(error => {
            this.operations.forEach(item => typeof item.reject === 'function' && item.reject(error))
            throw error
        })
    }

    getRoutes() {
        return this.operations.map(item => ({
            url: '/api' + (item.url.substring(0,1) === '/' ? item.url : '/' + item.url) ,
            method: item.method,
            params: typeof item.params === 'function' ? item.params() : item.params,
        }))
    }

    /**
     * @param { BulkOperation.Operation } operation
     * @return this
     */
    add(operation) {
        this.operations.push(operation)

        return this
    }
}
